const redirectToExternalURL = targetUrl => {
  if (!targetUrl.startsWith("http")) {
    throw new Error(`Invalid URL '${targetUrl}'`);
  }

  window.location.href = targetUrl;

  return new Promise(() => null);
};

module.exports = { redirectToExternalURL };
